var render, staticRenderFns
import script from "./CDialog.vue?vue&type=script&lang=ts"
export * from "./CDialog.vue?vue&type=script&lang=ts"
import style0 from "./CDialog.vue?vue&type=style&index=0&id=2df037fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports